const CategoryData =[
    {
        categoryTitle:'Load Scale',
        categoryImage:'../product-category-image/loader-scale-cate.png',
    },
    {
        categoryTitle:'Weight Machine',
        categoryImage:'../product-category-image/Weight-Scales.png',
    },
    {
        categoryTitle:'Grass Cutter',
        categoryImage:'../product-category-image/grass-cutters.png',
    },
    {
        categoryTitle:'Room Hitter',
        categoryImage:'../product-category-image/room-hitters.png',
    },
    {
        categoryTitle:'LED-Light',
        categoryImage:'../product-category-image/tube-lights.png',
    },
    {
        categoryTitle:'Sprea Machine',
        categoryImage:'../product-category-image/sprayer-Machines-02.png',
    }
    ,
    {
        categoryTitle:'Animal Mattress',
        categoryImage:'../product-category-image/mattress.png',
    },
    {
        categoryTitle:'Milk Detector',
        categoryImage:'../product-category-image/milk-detector.png',
    }
]
export default CategoryData;